import { Injectable } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { Md5 } from 'ts-md5/dist/md5';

import { InitConstant, UrlConstant, DialogConstant } from '../Constant';

import { AuthService } from './auth.service';
import { LogService } from './log.service';
import { LoadingService } from './loading.service';
import { DialogService } from './dialog.service';
import { ToastService } from './toast.service';
import { HttpService } from './http.service';

declare var window;

@Injectable({
    providedIn: 'root'
})
export class ApiService
{
    private status = [];
    private http_status = [];
    private message = [];

    constructor(
        private nav: NavController,
        private platform: Platform,
        private auth: AuthService,
        private log: LogService,
        private loading: LoadingService,
        private dialog: DialogService,
        private toast: ToastService,
        private http: HttpService
    ) 
    {
    }

    async login(uid, password, delete_devices)
    {
        await this.clearStatus('login');

        let select_devices: any;

        await this.loading.presentLoading();

        const token = InitConstant.INIT_TOKEN;
        const url = UrlConstant.BASE+UrlConstant.LOGIN;
        const uuid = Md5.hashStr(uid).toString();
        const model = await this.auth.getBrowserName();
        const device_name = 'ブラウザ'+(model != null ? `(${model})` : '');

        const formData = new FormData();
        formData.append('uid', uid);
        formData.append('password', password);
        formData.append('platform', 'browser');
        formData.append('uuid', 'PC::'+uuid);
        formData.append('device_name', device_name);

        for (let i = 0; i<delete_devices.length; i++) {
            formData.append(`delete_devices[${i}]`, delete_devices[i]);
        }

        this.log.debug([`login -> ${url}`, formData]);

        await this.http.request('post', url, formData, token, null, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`login -> resp`, resp]);

                const data = resp.body;
                this.status['login'] = data['status'];

                if (data['status'] == 1) {
                    this.auth.setUserId(data['user_id']);
                    this.auth.setToken(data['token']);
                    this.auth.setDeviceName(data['device_name']);
                } else if (data['status'] == 3) {
                    select_devices = data['select_devices'];
                } else {
                    this.message['login'] = data['message'];
                }

                this.loading.closeLoading();
            })
            .catch(e => {
                this.log.error([`login -> failure`, e]);
                this.http_status['login'] = Number(e.status);
                this.loading.closeLoading();
            });

        return {
            status: this.status['login'],
            select_devices: select_devices
        }
    }

    async logout()
    {
        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.LOGOUT;

        this.log.debug(`logout -> ${url}`);

        await this.http.request('get', url, null, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`logout -> resp`, resp]);
                this.clearStatus('logout');
                this.auth.redirectToDefault(true);
            })
            .catch(e => {
                this.log.error([`logout -> failure`, e]);
                this.clearStatus('logout');
                this.auth.redirectToDefault(true);
            });
    }

    async reminder(uid)
    {
        const proc_id = `reminder:${uid}`;

        await this.clearStatus(proc_id);

        const token = InitConstant.INIT_TOKEN;
        const url = UrlConstant.BASE+UrlConstant.REMINDER;

        const formData = new FormData();
        formData.append('uid', uid);

        this.log.debug([`reminder -> ${url}`, formData]);

        await this.http.request('post', url, formData, token, null, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`reminder -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }
            })
            .catch(e => {
                this.log.error([`reminder -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
            });

        return this.status[proc_id] == 1;
    }

    async remindersend(reminder_key, password, password_confirm)
    {
        await this.clearStatus('remindersend');

        const token = InitConstant.INIT_TOKEN;
        const url = UrlConstant.BASE+UrlConstant.REMINDERSEND;

        const formData = new FormData();
        formData.append('reminder_key', reminder_key);
        formData.append('password', password);
        formData.append('password_confirm', password_confirm);

        this.log.debug([`remindersend -> ${url}`, formData]);

        return await this.http.request('post', url, formData, token, null, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`remindersend -> resp`, resp]);

                const data = resp.body;
                this.status['remindersend'] = data['status'];

                if (data['status'] == 1) {
                    return true;
                } else {
                    this.message['remindersend'] = data['message'];
                    return false;
                }
            })
            .catch(e => {
                this.log.error([`remindersend -> failure`, e]);
                this.http_status['remindersend'] = Number(e.status);
                return false;
            });
    }

    async approveemail(email_key)
    {
        await this.clearStatus('approveemail');

        const token = InitConstant.INIT_TOKEN;
        const url = UrlConstant.BASE+UrlConstant.APPROVEEMAIL;

        const formData = new FormData();
        formData.append('email_key', email_key);

        this.log.debug([`approveemail -> ${url}`, formData]);

        return await this.http.request('post', url, formData, token, null, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`approveemail -> resp`, resp]);

                const data = resp.body;
                this.status['approveemail'] = data['status'];

                if (data['status'] == 1) {
                    return true;
                } else {
                    this.message['approveemail'] = data['message'];
                    return false;
                }
            })
            .catch(e => {
                this.log.error([`approveemail -> failure`, e]);
                this.http_status['approveemail'] = Number(e.status);
                return false;
            });
    }

    async cancel(params)
    {
        const proc_id = `cancel:`+params['now_mtime'];

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.CANCEL;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return false;
        }

        const formData = new FormData();
        formData.append('file_flg', params['file_flg']);
        formData.append('parent_id', params['parent_id']);
        formData.append('file_name', params['file_name']);

        this.log.debug([`cancel -> ${url}`, formData]);

        await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`cancel -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }
            })
            .catch(e => {
                this.log.error([`cancel -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
            });

        return this.status[proc_id] == 1;
    }

    async getfilelist(file_cache_id)
    {
        const proc_id = `getfilelist:${file_cache_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.FILELIST+(!this.auth.empty(file_cache_id) ? '/'+file_cache_id : '');

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return [];
        }

        this.log.debug(`getfilelist -> ${url}`);

        const resp_data = await this.http.request('get', url, null, token, user_id, null, 'json')
            .toPromise()
            .then(async(resp) => {
                this.log.debug([`getfilelist -> resp`, resp]);
                const data = resp.body;

                if (!this.auth.empty(data['token'])) {
                    await this.auth.setToken(data['token']);
                }

                return data['list'];
            })
            .catch(e => {
                this.log.error([`getfilelist -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return [];
            });

        return resp_data;
    }

    async searchlist(params)
    {
        const proc_id = `searchlist:${params.file_cache_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.PC_FILELIST+'/'+params.type;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return [];
        }

        const formData = new FormData();
        formData.append('file_cache_id', params.file_cache_id);
        formData.append('limit', params.limit);
        formData.append('offset', params.offset);
        formData.append('order', params.order);
        formData.append('sort', params.sort);
        formData.append('sort_folder', params.sort_folder);
        formData.append('keyword', params.keyword);
        formData.append('show_hidden', params.show_hidden);

        this.log.debug(`searchlist -> file_cache_id: ${params.file_cache_id} / limit: ${params.limit} / offset: ${params.offset} / order: ${params.order} / sort: ${params.sort} / sort_folder: ${params.sort_folder} / keyword: ${params.keyword} / show_hidden: ${params.show_hidden} / type: ${params.type}`);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(async(resp) => {
                this.log.debug([`searchlist -> resp`, resp]);
                const data = resp.body;
                return data['list'];
            })
            .catch(e => {
                this.log.error([`searchlist -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return [];
            });

        return resp_data;
    }

    async getfile(file_name, parent_id, now_mtime, force_delete, trash_flg)
    {
        const proc_id = `getfile:${now_mtime}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.GETFILE;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append('parent_id', parent_id);
        formData.append('file_name', file_name);
        formData.append('trash_flg', trash_flg);

        if (force_delete === true) {
            formData.append('force_delete', "1");
        }

        this.log.debug(`getfile -> file_name: ${file_name} / parent_id: ${parent_id}`);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(async(resp) => {
                this.log.debug([`getfile -> resp`, resp]);
                const data = resp.body;
                return data['row'];
            })
            .catch(e => {
                this.log.error([`getfile -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async breadcrumb(parent_id)
    {
        const proc_id = `breadcrumb:${parent_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.GETBREADCRUMBS;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return { num: 0, list: [] };
        }

        const formData = new FormData();
        formData.append('parent_id', parent_id);

        this.log.debug(`breadcrumb -> parent_id: ${parent_id}`);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(async(resp) => {
                this.log.debug([`breadcrumb -> resp`, resp]);
                const data = resp.body;
                let num = data['num'];
                let list = data['list'];

                return { num: num, list: list };
            })
            .catch(e => {
                this.log.error([`breadcrumb -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return { num: 0, list: [] };
            });

        return resp_data;
    }

    async ziparchives(files, parent_id)
    {
        const proc_id = `ziparchives:${parent_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.PC_ZIPARCHIVES;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();

        let cnt = 0;
        for (let i = 0; i<files.length; i++) {
            if (files[i].status == 0) {
                continue;
            }

            if (files[i].checked == 1) {
                formData.append(`file_cache_ids[${cnt}]`, files[i].id);
                formData.append(`file_flgs[${cnt}]`, files[i].file_flg);
                cnt++;
            }
        }

        if (cnt > InitConstant.MAX_POST_LIMIT_COUNT) {
            this.status[proc_id] = 0;
            this.message[proc_id] = DialogConstant.FILE_DOWNLOAD_LIMIT_ERR;
            return null;
        }

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(async(resp) => {
                this.log.debug([`ziparchives -> resp`, resp]);
                const data = resp.body;

                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data['dl_id'];
            })
            .catch(e => {
                this.log.error([`ziparchives -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async zipprogress()
    {
        const proc_id = `zipprogress`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.PC_ZIPPROGRESS;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return [];
        }

        this.log.debug(`zipprogress -> ${url}`);

        const resp = await this.http.request('get', url, null, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`zipprogress -> resp`, resp]);
                const data = resp.body;
                return data['list'];
            })
            .catch(e => {
                this.log.error([`zipprogress -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return [];
            });

        return resp;
    }

    async fileupload(params)
    {
        const proc_id = `fileupload:`+params['now_mtime'];

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.CREATE;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append('file_flg', params['file_flg']);
        formData.append('parent_id', params['parent_id']);
        formData.append('file_name', params['file_name']);
        formData.append('file_size', params['file_size']);
        formData.append('file_mtime', params['file_mtime']);
        formData.append('file_mime_type', params['file_mime_type']);
        formData.append('total_count', params['total_count']);
        formData.append('upload_count', params['upload_count']);
        formData.append('duplicate', params['duplicate']);
        formData.append('data', params['data']);

        this.log.debug(`fileupload -> file_name: `+params['file_name']+` / total_count: `+params['total_count']+` / upload_count: `+params['upload_count']);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`fileupload -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`fileupload -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async profileicon()
    {
        const proc_id = 'profileicon';

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.PROFILEICON;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        this.log.debug(`profileicon -> ${url}`);

        const blob = await this.http.request('get', url, null, token, user_id, null, 'blob')
            .toPromise()
            .then(resp => {
                const content_type = resp.headers.get('Content-Type');
                let blob = [];
                blob.push(resp.body);
                return new Blob(blob, { type: content_type });
            })
            .catch(e => {
                this.log.error([`profileicon -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return blob;
    }

    async profile()
    {
        const proc_id = 'profile';

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.PROFILE;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return [];
        }

        this.log.debug(`profileicon -> ${url}`);

        const data = await this.http.request('get', url, null, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                const data = resp.body;
                return data;
            })
            .catch(e => {
                this.log.error([`profile -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return [];
            });

        return data;
    }

    async updateicon(params, is_remove)
    {
        const proc_id = `updateicon`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.UPDATE_PROFILEICON;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();

        if (is_remove === false) {
            formData.append('file_name', params['file_name']);
            formData.append('file_size', params['file_size']);
            formData.append('file_mime_type', params['file_mime_type']);
            formData.append('data', params['data']);
        } else {
            formData.append('remove', "1");
        }

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`updateicon -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`updateicon -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async updatename(display_name)
    {
        const proc_id = `updatename`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.UPDATE_PROFILENAME;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append('display_name', display_name);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`updatename -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`updatename -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async updateemail(email)
    {
        const proc_id = `updateemail`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.UPDATE_PROFILEEMAIL;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append('email', email);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`updateemail -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`updateemail -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async updatepassword(password)
    {
        const proc_id = `updatepassword`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.UPDATE_PROFILEPASSWORD;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append('password', password);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`updatepassword -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`updatepassword -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async updatedevice(devices)
    {
        const proc_id = `updatedevice`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.UPDATE_PROFILEDEVICE;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();

        for (let i = 0; i < devices.length; i++) {
            formData.append("devices["+i+"]", devices[i]);
        }

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`updatedevice -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`updatedevice -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async getthumbnail(file_cache_id)
    {
        const proc_id = `getthumbnail:${file_cache_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.THUMBNAIL+'/'+file_cache_id;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        this.log.debug(`getthumbnail -> ${url}`);

        const blob = await this.http.request('get', url, null, token, user_id, null, 'blob')
            .toPromise()
            .then(resp => {
                const content_type = resp.headers.get('Content-Type');
                let blob = [];
                blob.push(resp.body);
                return new Blob(blob, { type: content_type });
            })
            .catch(e => {
                this.log.error([`getthumbnail -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return blob;
    }

    async addtrash(file_cache_id, file_flg, file_cache_parent_id)
    {
        const proc_id = `addtrash:${file_cache_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.TRASH;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append("file_flgs[0]", file_flg);
        formData.append("file_cache_ids[0]", file_cache_id);
        formData.append("parent_id", file_cache_parent_id);
        formData.append("trash_type", "0");

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`addtrash -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`addtrash -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async addtrashes(files, file_cache_parent_id)
    {
        const proc_id = `addtrashes:${file_cache_parent_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.TRASH;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();

        let cnt = 0;
        for (let i = 0; i<files.length; i++) {
            if (files[i].checked == 1) {
                formData.append(`file_flgs[${cnt}]`, files[i].file_flg);
                formData.append(`file_cache_ids[${cnt}]`, files[i].id);
                cnt++;
            }
        }

        if (cnt > InitConstant.MAX_POST_LIMIT_COUNT) {
            this.status[proc_id] = 0;
            this.message[proc_id] = DialogConstant.FILE_TRASH_ADD_LIMIT_ERR;
            return null;
        }

        formData.append("parent_id", file_cache_parent_id);
        formData.append("trash_type", "0");

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`addtrashes -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`addtrashes -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async restoretrash(file_cache_id, file_flg)
    {
        const proc_id = `restoretrash:${file_cache_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.TRASH;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append("file_flg", file_flg);
        formData.append("file_cache_id", file_cache_id);
        formData.append("trash_type", "1");

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`restoretrash -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`restoretrash -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async restoretrashes(files, file_cache_parent_id)
    {
        const proc_id = `restoretrashes:${file_cache_parent_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.TRASH;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();

        let cnt = 0;
        for (let i = 0; i<files.length; i++) {
            if (files[i].checked == 1) {
                formData.append(`file_flgs[${cnt}]`, files[i].file_flg);
                formData.append(`file_cache_ids[${cnt}]`, files[i].id);
                cnt++;
            }
        }

        if (cnt > InitConstant.MAX_POST_LIMIT_COUNT) {
            this.status[proc_id] = 0;
            this.message[proc_id] = DialogConstant.FILE_TRASH_RESTORE_LIMIT_ERR;
            return null;
        }

        formData.append("trash_type", "4");

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`restoretrashes -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`restoretrashes -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async deletetrash(file_cache_id, file_flg)
    {
        const proc_id = `deletetrash:${file_cache_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.TRASH;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append("file_flg", file_flg);
        formData.append("file_cache_id", file_cache_id);
        formData.append("trash_type", "2");

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`deletetrash -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`deletetrash -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async deletetrashes(files, file_cache_parent_id)
    {
        const proc_id = `deletetrashes:${file_cache_parent_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.TRASH;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();

        let cnt = 0;
        for (let i = 0; i<files.length; i++) {
            if (files[i].checked == 1) {
                formData.append(`file_flgs[${cnt}]`, files[i].file_flg);
                formData.append(`file_cache_ids[${cnt}]`, files[i].id);
                cnt++;
            }
        }

        if (cnt > InitConstant.MAX_POST_LIMIT_COUNT) {
            this.status[proc_id] = 0;
            this.message[proc_id] = DialogConstant.FILE_TRASH_DELETE_LIMIT_ERR;
            return null;
        }

        formData.append("trash_type", "5");

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`deletetrashes -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`deletetrashes -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async deletealltrash()
    {
        const proc_id = `deletealltrash`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.TRASH;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append("trash_type", "3");

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`deletealltrash -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`deletealltrash -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async addfavorites(files, file_cache_parent_id, favorite_flg)
    {
        const proc_id = `addfavorites:${file_cache_parent_id}`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.ADDFAVORITE;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append("favorite_flg", String(favorite_flg));

        let cnt = 0;
        for (let i = 0; i<files.length; i++) {
            if (files[i].status == 0 || files[i].favorite_flg == favorite_flg) {
                continue;
            }

            if (files[i].checked == 1) {
                formData.append(`file_flgs[${cnt}]`, files[i].file_flg);
                formData.append(`file_cache_ids[${cnt}]`, files[i].id);
                cnt++;
            }
        }

        if (cnt == 0) {
            this.status[proc_id] = 200;
            return null;
        }

        if (cnt > InitConstant.MAX_POST_LIMIT_COUNT) {
            this.status[proc_id] = 0;
            if (favorite_flg == 1) {
                this.message[proc_id] = DialogConstant.FILE_FAVORITE_ADD_LIMIT_ERR;
            } else {
                this.message[proc_id] = DialogConstant.FILE_FAVORITE_DEL_LIMIT_ERR;
            }

            return null;
        }

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`addfavorites -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`addfavorites -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async addfavorite(file_cache_id, file_flg, favorite_flg)
    {
        const proc_id = `addfavorite:`+file_cache_id;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.ADDFAVORITE;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append("file_cache_ids[0]", file_cache_id);
        formData.append("file_flgs[0]", file_flg);
        formData.append("favorite_flg", favorite_flg);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`addfavorite -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`addfavorite -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async rename(file_cache_id, file_flg, parent_id, new_file_name)
    {
        const proc_id = `rename:`+file_cache_id;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.RENAME;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append("file_cache_id", file_cache_id);
        formData.append("file_flg", file_flg);
        formData.append("parent_id", parent_id);
        formData.append("file_name", new_file_name);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`rename -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`rename -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async createfolder(parent_id, file_name)
    {
        const proc_id = `createfolder:`+parent_id;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.CREATE;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const now_mtime = Math.floor(Date.now() / 1000);

        const formData = new FormData();
        formData.append('file_flg', "0");
        formData.append('parent_id', parent_id);
        formData.append('file_name', file_name);
        formData.append('file_size', "0");
        formData.append('file_mtime', String(now_mtime));
        formData.append('total_count', "1");
        formData.append('upload_count', "1");
        formData.append('duplicate', "0");

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`createfolder -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`createfolder -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async move(file_cache_id, file_flg, new_parent_id)
    {
        const proc_id = `move:`+file_cache_id;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.MOVE;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append("file_cache_ids[0]", file_cache_id);
        formData.append("file_flgs[0]", file_flg);
        formData.append("new_parent_id", new_parent_id);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`move -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`move -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async moves(files, new_parent_id)
    {
        const proc_id = `move:`+new_parent_id;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.MOVE;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append("new_parent_id", new_parent_id);

        let cnt = 0;
        for (let i = 0; i<files.length; i++) {
            if (files[i].status == 0) {
                continue;
            }

            if (files[i].checked == 1) {
                formData.append(`file_flgs[${cnt}]`, files[i].file_flg);
                formData.append(`file_cache_ids[${cnt}]`, files[i].id);
                cnt++;
            }
        }

        if (cnt > InitConstant.MAX_POST_LIMIT_COUNT) {
            this.status[proc_id] = 0;
            this.message[proc_id] = DialogConstant.FILE_MOVE_LIMIT_ERR;
            return null;
        }

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`moves -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`moves -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async copy(file_cache_id, parent_id, to_parent_id, file_name, overwrite)
    {
        const proc_id = `copy:`+file_cache_id;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.COPY;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return null;
        }

        const formData = new FormData();
        formData.append("file_cache_id", file_cache_id);
        formData.append("parent_id", parent_id);
        formData.append("to_parent_id", to_parent_id);
        formData.append("file_name", file_name);
        formData.append("overwrite", overwrite);

        const resp_data = await this.http.request('post', url, formData, token, user_id, null, 'json')
            .toPromise()
            .then(resp => {
                this.log.debug([`copy -> resp`, resp]);

                const data = resp.body;
                this.status[proc_id] = data['status'];

                if (data['status'] != 1) {
                    this.message[proc_id] = data['message'];
                }

                return data;
            })
            .catch(e => {
                this.log.error([`copy -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return null;
            });

        return resp_data;
    }

    async getwarning()
    {
        const proc_id = `getwarning`;

        await this.clearStatus(proc_id);

        const token = await this.auth.getToken();
        const user_id = await this.auth.getUserId();
        const url = UrlConstant.BASE+UrlConstant.WARNING;

        if (this.auth.empty(user_id)) {
            this.status[proc_id] = 401;
            return [];
        }

        this.log.debug(`getwarning -> ${url}`);

        const resp_data = await this.http.request('get', url, null, token, user_id, null, 'json')
            .toPromise()
            .then(async (resp) => {
                this.log.debug([`getwarning -> resp`, resp]);
                const data = resp.body;

                return data;
            })
            .catch(e => {
                this.log.error([`getwarning -> failure`, e]);
                this.http_status[proc_id] = Number(e.status);
                return [];
            });

        return resp_data;
    }

    clearStatus(key)
    {
        this.status[key] = 0;
        this.http_status[key] = 200;
        this.message[key] = null;
    }

    getMessage(key)
    {
        return this.message[key];
    }

    setErrorDialog(key)
    {
        const message = this.getMessage(key);

        if (!this.auth.empty(message)) {
            this.dialog.message(DialogConstant.ERROR_TITLE, message, DialogConstant.BUTTON_OK);
        } else {
            if (this.isAuthErr(key)) {
                this.dialog.message(DialogConstant.ERROR_TITLE, DialogConstant.AUTH_ERR, DialogConstant.BUTTON_OK);
            } else if (this.isNotfoundErr(key)) {
                this.dialog.message(DialogConstant.ERROR_TITLE, DialogConstant.NOTFOUND_ERR, DialogConstant.BUTTON_OK);
            } else if (this.isAuthErr(key) || this.isRequestErr(key)) {
                this.dialog.message(DialogConstant.ERROR_TITLE, DialogConstant.REQUEST_ERR, DialogConstant.BUTTON_OK);
            } else if (this.isInternalErr(key)) {
                this.dialog.message(DialogConstant.ERROR_TITLE, DialogConstant.INTERNAL_ERR, DialogConstant.BUTTON_OK);
            } else if (this.isInsufficientStorageErr(key)) {
                this.dialog.message(DialogConstant.ERROR_TITLE, DialogConstant.INSUFFICIENTSTORAGE_ERR, DialogConstant.BUTTON_OK);
            } else if (this.isMaintenanceErr(key)) {
                this.dialog.message(DialogConstant.ERROR_TITLE, DialogConstant.MAINTENANCE_ERR, DialogConstant.BUTTON_OK);
            } else {
                this.dialog.message(DialogConstant.ERROR_TITLE, DialogConstant.NETWORK_ERR, DialogConstant.BUTTON_OK);
            }
        }
    }

    setErrorToast(key)
    {
        const message = this.getMessage(key);

        if (!this.auth.empty(message)) {
            this.toast.errorNotification(message);
        } else {
            if (this.isAuthErr(key)) {
                this.toast.errorNotification(DialogConstant.AUTH_ERR);
            } else if (this.isNotfoundErr(key)) {
                this.toast.errorNotification(DialogConstant.NOTFOUND_ERR);
            } else if (this.isAuthErr(key) || this.isRequestErr(key)) {
                this.toast.errorNotification(DialogConstant.REQUEST_ERR);
            } else if (this.isInternalErr(key)) {
                this.toast.errorNotification(DialogConstant.INTERNAL_ERR);
            } else if (this.isInsufficientStorageErr(key)) {
                this.toast.errorNotification(DialogConstant.INSUFFICIENTSTORAGE_ERR);
            } else if (this.isMaintenanceErr(key)) {
                this.toast.errorNotification(DialogConstant.MAINTENANCE_ERR);
            } else {
                this.toast.errorNotification(DialogConstant.NETWORK_ERR);
            }
        }
    }

    isSuccess(key)
    {
        const message = this.getMessage(key);

        if (!this.auth.empty(message)) {
            return false;
        } else if (this.isAuthErr(key) || this.isRequestErr(key) || this.isInternalErr(key) || this.isInsufficientStorageErr(key)  ||this.isMaintenanceErr(key) || this.isNotfoundErr(key) || this.isNetworkErr(key)) {
            return false;
        }

        return true;
    }

    getErrorMessage(key)
    {
        const message = this.getMessage(key);

        if (!this.auth.empty(message)) {
            return message;
        }

        if (this.isAuthErr(key) || this.isRequestErr(key)) {
            return DialogConstant.REQUEST_ERR;
        } else if (this.isInternalErr(key)) {
            return DialogConstant.INTERNAL_ERR;
        } else if (this.isInsufficientStorageErr(key)) {
            return DialogConstant.INSUFFICIENTSTORAGE_ERR;
        } else if (this.isMaintenanceErr(key)) {
            return DialogConstant.MAINTENANCE_ERR;
        } else {
            return DialogConstant.NETWORK_ERR;
        }
    }

    isAuthErr(key)
    {
        let regexpNumber: RegExp = /^401$/;
        return regexpNumber.test(this.http_status[key]);
    }

    isRequestErr(key)
    {
        let regexpNumber: RegExp = /^40[02356789]$/;
        return regexpNumber.test(this.http_status[key]);
    }

    isNotfoundErr(key)
    {
        let regexpNumber: RegExp = /^404$/;
        return regexpNumber.test(this.http_status[key]);
    }

    isInternalErr(key)
    {
        let regexpNumber: RegExp = /^50[01245689]$/;
        return regexpNumber.test(this.http_status[key]);
    }

    isInsufficientStorageErr(key)
    {
        let regexpNumber: RegExp = /^507$/;
        return regexpNumber.test(this.http_status[key]);
    }

    isMaintenanceErr(key)
    {
        let regexpNumber: RegExp = /^503$/;
        return regexpNumber.test(this.http_status[key]);
    }

    isNetworkErr(key)
    {
        let regexpNumber: RegExp = /^0$/;
        return regexpNumber.test(this.http_status[key]) || Number.isNaN(this.http_status[key]);
    }
}
